import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

// Set the default timezone to LA
dayjs.tz.setDefault('America/Los_Angeles');

export default dayjs;